import { Link } from 'react-router-dom';
import { TOKO_APPS } from '@/config/apps';
import styles from './AppGrid.module.css';

interface AppGridProps {
  enabledApps?: string[];
  onAppClick?: (appId: string) => void;
  linkOverrides?: Record<string, string>;
  disabledClickable?: boolean;
}

export function AppGrid({ enabledApps, onAppClick, linkOverrides, disabledClickable = false }: AppGridProps) {
  const allEnabled = enabledApps === undefined;

  return (
    <div className={styles.grid}>
      {TOKO_APPS.filter((app) => app.id !== 'addition-plus').map((app) => {
        const isEnabled = allEnabled || enabledApps.includes(app.id);
        const href = linkOverrides?.[app.id] ?? app.appStoreUrl;

        const handleClick = (e: React.MouseEvent) => {
          if (!isEnabled && !disabledClickable) {
            e.preventDefault();
            return;
          }
          if (onAppClick) {
            e.preventDefault();
            onAppClick(app.id);
          }
        };

        const classNames = [styles.appCard];
        if (!isEnabled) {
          classNames.push(styles.disabled);
          if (disabledClickable) {
            classNames.push(styles.clickable);
          }
        }

        return (
          <Link
            key={app.id}
            to={href}
            className={classNames.join(' ')}
            onClick={handleClick}
            style={{ '--app-color': app.color } as React.CSSProperties}
          >
            <div className={styles.iconWrapper}>
              <img src={app.icon} alt={app.name} className={styles.icon} />
            </div>
            <span className={styles.appName}>{app.shortName}</span>
          </Link>
        );
      })}
    </div>
  );
}
